import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

export const showEnter = trigger("showEnter", [
  transition(":enter", [
    style({ opacity: 0 }),
    animate("150ms ease-in-out", style({ opacity: "*" })),
  ]),
]);

export const show = trigger("show", [
  transition(":enter", [
    style({ opacity: 0 }),
    animate("150ms ease", style({ opacity: "*" })),
  ]),
  transition(":leave", [
    style({ opacity: "*" }),
    animate("150ms ease-in-out", style({ opacity: 0 })),
  ]),
]);

export const openClose = trigger("openClose", [
  transition(":enter", [
    style({ opacity: 0, height: 0 }),
    animate("100ms ease-in-out", style({ height: "*" })),
    animate("100ms ease-in-out", style({ opacity: "*" })),
  ]),
  transition(":leave", [
    style({ opacity: "*", height: "*" }),
    animate("100ms ease-in-out", style({ opacity: 0 })),
    animate("100ms ease-in-out", style({ height: 0 })),
  ]),
]);

export const slideInOut = trigger("slideInOut", [
  state(
    "in",
    style({
      height: "*",
      opacity: 1,
      overflow: "hidden",
    }),
  ),
  state(
    "out",
    style({
      height: "0px",
      opacity: 0,
      overflow: "hidden",
    }),
  ),
  transition("in => out", [animate("300ms ease-in-out")]),
  transition("out => in", [animate("300ms ease-in-out")]),
]);

export const itemState = trigger("itemState", [
  transition("* => open", [
    style({ opacity: 0, left: "-100%" }),
    animate(
      "350ms cubic-bezier(0, 0, 0.2, 1)",
      style({ opacity: 1, left: "*" }),
    ),
  ]),
]);

export const loading = trigger("loading", [
  transition(":enter", [
    style({ opacity: 0, height: 0 }),
    animate("200ms", style({ height: "*" })),
    animate("150ms", style({ opacity: 1 })),
  ]),
  transition(":leave", [
    style({ opacity: 1, height: "*" }),
    animate("150ms", style({ opacity: 0 })),
    animate("200ms", style({ height: 0 })),
  ]),
]);
